import mock from "../mock"
export let buildingsList = [
  {
    id: 1,
    active_status: true,
    name: "Deluxe Family",
    no_of_floors: ["Ground","Second","Third"],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 2,
    active_status: false,
    name: "Allamanda",
    no_of_floors: ["First","Second","Third"],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 3,
    active_status: true,
    name: "Standard",
    no_of_floors: ["Second","Fourth"],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 4,
    active_status: false,
    name: "Pool View Standard",
    no_of_floors: ["Third"],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 5,
    active_status: true,
    name: "Deluxe",
    no_of_floors: ["Ground","Fourth"],
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 6,
    active_status: false,
    name: "Stanard Triple",
    no_of_floors: ["First","Third"],
    desc: "Lorem ipsum doler sit amith"
  },  
]

// GET DATA
mock.onGet("/api/buildingsList/initial-data").reply(response => {
  return [200, buildingsList]
})

mock.onGet("/api/buildingsList/data").reply(response => {
  let { page, perPage } = response  
  let totalPages = Math.ceil(buildingsList.length / perPage)
  if (page !== undefined && perPage !== undefined) {
    let calculatedPage = (page - 1) * perPage    
    let calculatedPerPage = page * perPage
    return [
      200,
      { data: buildingsList.slice(calculatedPage, calculatedPerPage), totalPages }
    ]
  } else {
    return [
      200,
      { data: buildingsList.slice(0, 10), totalPages: Math.ceil(buildingsList.length / 10) }
    ]
  }
})

// UPDATE DATA
mock.onPost("/api/buildingsList/update-data").reply(request => {
  //let data = JSON.parse(request.data).obj
  buildingsList.map(item => {
    return item    
  })
  return [200]
})

// Add DATA
mock.onPost("/api/buildingsList/add-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let highestId = Math.max.apply(
    Math,
    buildingsList.map(i => i.id)
  )
  buildingsList.unshift({
    ...data,
    id: highestId + 1,
    
  })
  return [200]
})

// DELETE DATA
mock.onPost("/api/buildingsList/delete-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let index = buildingsList.findIndex(item => item.id === data.id)
  buildingsList.splice(index, 1)
  return [200]
})

// DELETE SELECTED DATA
mock.onPost("/api/buildingsList/delete-selected").reply(request => {
  let data = JSON.parse(request.data).arr
  let reducedArray
  ;[buildingsList, data].reduce((a, b) => {
    let c = b.map(j => j.id)
    return (reducedArray = a.filter(i => !c.includes(i.id)))
  })
  buildingsList = reducedArray
  return [200]
})
